import Cookies from 'js-cookie'

import { callNotification } from '@/shared/lib/call-notification/call-notification'

import { SignInResponseData } from '../types/auth-schema'

const AUTH_COOKIE_OPTIONS = {
	domain: '.iport.ru',
	path: '/',
	expires: 21
} as const

type PersistAuthSessionParams = {
	tokens: SignInResponseData
	setSessionToken: (token: string) => void
	onSuccess?: () => void
}

//Сохранение токенов в cookie и вызов колбека при успешной авторизации
export const persistAuthSession = ({ tokens, setSessionToken, onSuccess }: PersistAuthSessionParams) => {
	setSessionToken(tokens.ACCESS_TOKEN)
	Cookies.set('IS_EMAIL_INVALID', String(tokens.IS_EMAIL_INVALID ?? false), AUTH_COOKIE_OPTIONS)

	if (tokens.REFRESH_TOKEN) {
		Cookies.set('REFRESH_TOKEN', tokens.REFRESH_TOKEN, AUTH_COOKIE_OPTIONS)
	}

	callNotification.success('Вы успешно авторизовались')
	onSuccess?.()
}
